import { render, staticRenderFns } from "./ContactDataTable.vue?vue&type=template&id=374bcfe6"
import script from "./ContactDataTable.vue?vue&type=script&lang=js"
export * from "./ContactDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports